import { configVars } from 'src/helpers';
import defaultJson from 'src/i18n/default/en.json';
import { UnauthenticatedSessionProofType } from 'src/types/api';

export enum AxRoute {
  APPLICANT = 'applicant',
  ARGYLE_V2 = 'linking/argyle/v2',
  CONNECTED_PAYROLL = 'payroll_link'
}

export const PAYROLL_LINK_APPLICANT_EXPERIENCE_API_URL = `${configVars.applicant_experience_api_url}/${AxRoute.CONNECTED_PAYROLL}`;
export const APPLICANT_EXPERIENCE_API_URL = configVars.applicant_experience_api_url;
export const ARGYLE_V2_API_URL = `${APPLICANT_EXPERIENCE_API_URL}/${AxRoute.ARGYLE_V2}`;
export const HOW_TO_VIDEO_URL = 'https://vimeo.com/645372425';
export const ARGYLE_HOW_TO_VIDEO_URL = 'https://argyle-1.wistia.com/a/ubwz4x4htlxh9h6';
export const DOCUMENT_INSTRUCTIONS_URL = {
  en: 'https://snappt.docsend.com/view/a9ij9e22s22b3bt5',
  es: 'https://snappt.docsend.com/view/kjmmppu7x8sav5nk'
};
export const PRIVACY_POLICY_URL = 'https://www.snappt.com/privacy-policy';

export const UNAUTHENTICATED_SESSION_TOKEN_KEY = 'unauthenticated_session_token';

export const IS_TOS_CHECKED = 'is_tos_checked';

export const DOCUMENT_TYPES = [
  {
    value: UnauthenticatedSessionProofType.Paystub,
    label: defaultJson.documentType.paystub
  },
  {
    value: UnauthenticatedSessionProofType.BankStatement,
    label: defaultJson.documentType.bankStatement
  }
] satisfies { value: UnauthenticatedSessionProofType; label: string }[];
